import dayjs from 'dayjs';

import { WAITING_TIME_IN_DAYS } from './constants';
import { getFormattedStringFromDate, addNumberOfDays } from './dateUtils';

export const calculateDueDate = (rawDate?: Date | null) => {
  if (!rawDate) {
    return null;
  }

  const jsDate = dayjs(rawDate);
  const dueDate = addNumberOfDays(WAITING_TIME_IN_DAYS, jsDate);

  return getFormattedStringFromDate(dueDate);
};
